/*
  HO-CUSTOM: stop the sticky header and the collection/blog/search toolbar from causing
  layout shift (CLS) while the page scrolls.

  section-navigation-main.js hides and reveals the fixed header by writing an inline
  margin-top on #nav-wrapper on every scroll event, and keeps the sticky toolbar
  (.sticky-subheader) under the header with an inline margin-top / padding-top pair.
  Both are layout changes, and scroll is not user input, so every frame counted as a
  layout shift (~0.07 on every page, ~0.14 on collections, measured 2026-10-03).

  This leaves that script untouched and its inline values in place (other code reads
  them), and moves the same visual offset onto `transform`, which does not count as
  layout shift. A MutationObserver runs in the same task, before paint, so the header
  and toolbar sit exactly where they did before. CSS lives in custom.css (ho-nav-tx,
  ho-sub-tx). Revert: remove this file's script tag and those custom.css rules.
*/
(function () {
  var nav = document.getElementById('nav-wrapper');
  if (!nav || !window.MutationObserver) return;

  // A transform makes #nav-wrapper the containing block of its position:fixed
  // descendants (search/explore dropdowns, menus). Whenever any of those is open,
  // fall back to the theme's own margin so they stay where they belong.
  var OPEN = '[data-ho-search-dropdown]:not([hidden]),[data-ho-explore-dropdown]:not([hidden]),[open="true"]';

  function syncNav() {
    var y = parseFloat(nav.style.marginTop) || 0;
    var cl = nav.classList;
    var on = y < 0 && cl.contains('header-visible') && !cl.contains('reached-top') &&
      !cl.contains('above-overlay') && !document.body.classList.contains('no-scroll') &&
      !nav.querySelector(OPEN);
    var t = on ? 'translate3d(0,' + y + 'px,0)' : '';
    if (nav.style.transform !== t) nav.style.transform = t;
    if (cl.contains('ho-nav-tx') !== on) cl.toggle('ho-nav-tx', on);
  }

  var sub = document.querySelector('.sticky-subheader');
  function syncSub() {
    // The theme sets margin-top:-T and padding-top:T while stuck. custom.css swaps the
    // padding to the bottom (same border box, same flow) and the inner row is moved
    // down by T with a transform instead.
    var t = parseFloat(sub.style.paddingTop) || 0;
    var on = t > 0;
    var v = on ? t + 'px' : '';
    if (sub.style.getPropertyValue('--ho-sub-y') !== v) {
      if (on) sub.style.setProperty('--ho-sub-y', v); else sub.style.removeProperty('--ho-sub-y');
    }
    if (sub.classList.contains('ho-sub-tx') !== on) sub.classList.toggle('ho-sub-tx', on);
  }

  var stateObserver = new MutationObserver(function (records) {
    var navChanged = false;
    var subChanged = false;
    records.forEach(function (record) {
      if (record.target === nav || record.target === document.body) navChanged = true;
      if (record.target === sub) subChanged = true;
    });
    if (navChanged) syncNav();
    if (subChanged) syncSub();
  });
  stateObserver.observe(nav, { attributes: true, attributeFilter: ['style', 'class'] });
  stateObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  if (sub) stateObserver.observe(sub, { attributes: true, attributeFilter: ['style', 'class'] });

  // Descendant slider/menu positioning does not affect OPEN. Keep nested panel
  // signals without subscribing to their animation styles or classes. A separate
  // observer preserves nav's own state registration: observe() replaces options
  // when called twice for the same node on one observer.
  var panelObserver = new MutationObserver(syncNav);
  panelObserver.observe(nav, { subtree: true, attributes: true, attributeFilter: ['hidden', 'open'] });
  syncNav();
  if (sub) syncSub();
})();
